(function () {
  // Prevent double-loading (snippets can be rendered multiple times)
  if (window.__omkReadTimeLoaded) return;
  window.__omkReadTimeLoaded = true;

  function computeOne(el) {
    const selector = el.getAttribute("data-target") || ".blog-content-desc.rte";
    const content = document.querySelector(selector);
    if (!content) return false;

    const text = (content.textContent || "").replace(/\s+/g, " ").trim();
    if (!text) return false;

    const wpm = parseInt(el.getAttribute("data-wpm") || "200", 10);
    const wordCount = text.split(" ").filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(wordCount / wpm));
    const suffix = minutes > 1 ? "minutter" : "minut";
    const prefix = el.getAttribute("data-prefix") || "⏱ Læsetid: ca.";

    el.textContent = prefix + " " + minutes + " " + suffix;
    el.setAttribute("data-words", String(wordCount));
    el.setAttribute("data-minutes", String(minutes));
    return true;
  }

  function computeAll() {
    document.querySelectorAll(".omk-read-time[data-wpm]").forEach(function (el) {
      // Compute only if not already computed
      if (!el.getAttribute("data-minutes")) computeOne(el);
    });
  }

  // Retry a few times (covers async rendering without heavy observers)
  function computeWithRetry(tries) {
    computeAll();
    const pending = document.querySelector(".omk-read-time[data-wpm]:not([data-minutes])");
    if (pending && tries > 0) {
      setTimeout(function () { computeWithRetry(tries - 1); }, 250);
    }
  }

  document.addEventListener("DOMContentLoaded", function () { computeWithRetry(12); });
  window.addEventListener("load", function () { computeWithRetry(12); });

  // Theme editor / section refresh
  document.addEventListener("shopify:section:load", function () { computeWithRetry(12); });
  document.addEventListener("shopify:section:select", function () { computeWithRetry(12); });
})();
